import { FC } from 'react'
import './TopMovie.scss'
import { IMovies } from '../../models/IMovies'
import { Link } from 'react-router-dom'
import noImg from '../../assets/img/no-img.webp'

interface TopMovieProps {
    topMovie: IMovies
    index: number
}

export const TopMovie: FC<TopMovieProps> = ({ topMovie, index }) => {

    return (
        <article className='top-movie'>
            <span className='top-movie__position'>{index + 1}</span>
            <Link className='' to={`/movie/${topMovie.id}`} key={topMovie.id}>
                <img className='top-movie__img' src={topMovie.posterUrl !== null ? topMovie.posterUrl : noImg} alt={topMovie.title} />
            </Link>
        </article>

    )
}